import React from 'react';
import { Row, Stack, Text, Tooltip } from 'library/ui';
import { InfoRounded } from '@mui/icons-material';

export function TitleDescription({
    title,
    description,
    infoText,
}: {
    title: string;
    description: string;
    infoText?: string;
}) {
    return (
        <Stack gap="none">
            <Text size="xs" weight="bold">
                {title}
            </Text>
            <Row gap="sm" align="center">
                <Text size="xs">{description}</Text>
                {infoText ? <Tooltip body={infoText} icon={InfoRounded} /> : null}
            </Row>
        </Stack>
    );
}
